import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/pages/AuthCallback";
import { SupportWidget } from "@/components/SupportWidget";
import { AdminBar } from "@/components/AdminBar";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import PostJob from "@/pages/PostJob";
import Ustalar from "@/pages/Ustalar";
import UstaProfile from "@/pages/UstaProfile";
import ProfileView from "@/pages/ProfileView";
import Wallet from "@/pages/Wallet";
import Messages from "@/pages/Messages";
import Account from "@/pages/Account";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import CategoryPage from "@/pages/CategoryPage";
import Admin from "@/pages/Admin";
import SetPassword from "@/pages/SetPassword";
import DeliveryReturns from "@/pages/DeliveryReturns";
import Privacy from "@/pages/Privacy";
import DistanceSales from "@/pages/DistanceSales";
import "@/App.css";

function Shell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <div className="min-h-screen flex flex-col app-bg">
      {!isAdmin && <Navbar />}
      {!isAdmin && <AdminBar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/sifre-belirle" element={<ProtectedRoute><SetPassword /></ProtectedRoute>} />
          <Route path="/ilanlar" element={<Jobs />} />
          <Route path="/ilan/:id" element={<JobDetail />} />
          <Route path="/ilan-ver" element={<PostJob />} />
          <Route path="/ustalar" element={<Ustalar />} />
          <Route path="/usta/:id" element={<UstaProfile />} />
          <Route path="/profil/:id" element={<ProfileView />} />
          <Route path="/kategori/:slug" element={<CategoryPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/nasil-calisir" element={<HowItWorks />} />
          <Route path="/teslimat-ve-iade" element={<DeliveryReturns />} />
          <Route path="/gizlilik-sozlesmesi" element={<Privacy />} />
          <Route path="/mesafeli-satis-sozlesmesi" element={<DistanceSales />} />
          <Route path="/cuzdanim" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
          <Route path="/mesajlar" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/hesabim" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <SupportWidget />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
